import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environment/environment';
var OwnRestrictedListService = /** @class */ (function () {
    function OwnRestrictedListService(httpClient) {
        this.httpClient = httpClient;
        /**
         * Environment variable
         */
        this.apiBase = environment.API_BASE;
    }
    OwnRestrictedListService.prototype.getOwnRestrictedList = function (restrictedRequest) {
        return this.httpClient.get(this.apiBase + "/api/own_sublists/" + restrictedRequest.id + "/");
    };
    OwnRestrictedListService.prototype.getOwnRestrictedLists = function (getOwnRestrictedListsRequest) {
        var params = new HttpParams();
        var url = this.apiBase + '/api/own_sublists/';
        var reqBodyEntries = Object.entries(getOwnRestrictedListsRequest);
        reqBodyEntries.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                params = params.append(key, value);
            }
        });
        return this.httpClient.get(url, { params: params });
    };
    OwnRestrictedListService.prototype.createOwnRestrictedList = function (restrictedAddRequest) {
        return this.httpClient
            .post(this.apiBase + "/api/own_sublists/", restrictedAddRequest);
    };
    OwnRestrictedListService.prototype.updateOwnRestrictedList = function (edtRestrictedAddRequest) {
        return this.httpClient
            .patch(this.apiBase + "/api/own_sublists/" + edtRestrictedAddRequest.id + "/", edtRestrictedAddRequest.data);
    };
    OwnRestrictedListService.prototype.getRestrictedNames = function (getOwnRestrictedNamesRequest) {
        var params = new HttpParams();
        var url = this.apiBase + ("/api/own_sublists/" + getOwnRestrictedNamesRequest.listId + "/own_names/");
        var reqBodyEntries = Object.entries(getOwnRestrictedNamesRequest.data);
        reqBodyEntries.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                params = params.append(key, value);
            }
        });
        return this.httpClient.get(url, { params: params });
    };
    OwnRestrictedListService.prototype.createRestrictedName = function (addOwnRestrictedNameRequest) {
        return this.httpClient
            .post(this.apiBase + "/api/own_sublists/" + addOwnRestrictedNameRequest.listId + "/own_names/", addOwnRestrictedNameRequest.data);
    };
    OwnRestrictedListService.prototype.editRestrictedName = function (editOwnRestrictedNameRequest) {
        return this.httpClient
            .patch(this.apiBase + "/api/own_names/" + editOwnRestrictedNameRequest.nameId + "/", editOwnRestrictedNameRequest.data);
    };
    return OwnRestrictedListService;
}());
export { OwnRestrictedListService };
